// Compact welcome moment for a brand-new org's first dashboard visit (docs/10
// #2.5). A banner, not a modal — it never blocks the page, and it disappears
// on its own once a screen is paired (or the user closes it, which never
// brings it back).

import { useNavigate } from '@tanstack/react-router';
import { Button } from '../components/ui.tsx';
import { useOnboarding } from './useOnboarding.ts';

export function WelcomeBanner() {
  const state = useOnboarding();
  const navigate = useNavigate();

  if (state.isLoading || !state.isYoungOrg || !state.hasNoScreens || state.welcomeDismissed) return null;

  return (
    <div className="welcome-banner" data-testid="welcome-banner">
      <div>
        <strong>Welcome to SeenCast.</strong>
        <p>Turn any screen into a display you control from here — content, schedule, and all.</p>
      </div>
      <div className="welcome-banner-actions">
        <Button variant="primary" onClick={() => navigate({ to: '/screens', search: { pair: true } })}>
          Start with your first screen
        </Button>
        <button
          type="button"
          className="gs-dismiss"
          aria-label="Dismiss welcome message"
          onClick={state.dismissWelcome}
        >
          ×
        </button>
      </div>
    </div>
  );
}
